import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const SegmentBuilderText = memo(function SegmentBuilderText({
  children,
}: {
  children: string;
}) {
  return (
    <Text
      fontSize="xs"
      fontWeight="medium"
      textColor="primary"
      whiteSpace="break-spaces"
    >
      {children}
    </Text>
  );
});
